import {
  contentVisualPreviewEmptyImageElement,
  contentVisualPreviewImageElement,
} from '@cohort/components-xps/components/contents/apps/utils';
import {Link} from '@phosphor-icons/react';

type CohortImageVisualPreviewContentProps = {
  imageSrc: string | null;
  title: string;
  className?: string;
};

const CohortLinkVisualPreviewContent: React.FC<CohortImageVisualPreviewContentProps> = ({
  imageSrc,
  title,
  className,
}) => {
  return imageSrc
    ? contentVisualPreviewImageElement(title, imageSrc, className)
    : contentVisualPreviewEmptyImageElement(<Link />, className);
};

export default CohortLinkVisualPreviewContent;
